import React, { memo } from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Martina Rossi',
  age: 22,
  city: 'Milano',
  text: 'Sono al 4° anno e questo pack mi ha messo ordine in testa come niente prima. Le tabelle dei dosaggi le ho salvate sul cellulare e in tirocinio valgono oro.'
}, {
  name: 'Luca Ferrari',
  age: 24,
  city: 'Torino',
  text: 'Il capitolo sulle emergenze mi ha salvato il turno. È arrivato un cane con colpo di calore e sapevo esattamente cosa fare. La scheda stampabile vale già da sola quello che ho pagato.'
}, {
  name: 'Sofia Esposito',
  age: 21,
  city: 'Napoli',
  text: 'Sentivo di studiare tantissimo senza trattenere nulla. Con il pianificatore di 90 giorni ho iniziato a memorizzare davvero. Ho passato patologia al primo tentativo con 29.'
}, {
  name: 'Marco Bianchi',
  age: 26,
  city: 'Bologna',
  text: 'Sono appena laureato e questo materiale mi avrebbe risparmiato ANNI di insicurezza. I modelli clinici li uso tutti i giorni nel mio primo lavoro. Consigliatissimo.'
}, {
  name: 'Giulia Romano',
  age: 23,
  city: 'Firenze',
  text: 'La farmacologia e i gatti mi terrorizzavano. Il bonus del prontuario con le controindicazioni segnalate mi ha cambiato il modo di ragionare su ogni caso. Vale ogni euro.'
}];
export function Testimonials() {
  return <section className="w-full py-16 px-4 bg-white" data-id="element-213">
      <div className="max-w-5xl mx-auto" data-id="element-214">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-slate-900" data-id="element-215">
          Cosa dicono altri studenti
        </h2>
        <p className="text-center text-slate-600 mt-3 max-w-2xl mx-auto" data-id="element-216">
          Più di 1.200 studenti stanno già studiando con criterio grazie a
          Carrera Veterinaria 360.
        </p>

        <div className="grid md:grid-cols-2 gap-5 mt-10" data-id="element-217">
          {testimonials.map((t, i) => <div key={i} className="bg-green-50/40 border border-green-100 rounded-2xl p-5 shadow-sm hover:shadow-md transition" data-id="element-218">
              <div className="flex items-center gap-1 mb-2" data-id="element-219">
                {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-220" />)}
              </div>
              <p className="text-slate-700 leading-relaxed text-sm sm:text-base" data-id="element-221">
                "{t.text}"
              </p>
              <div className="mt-4 flex items-center gap-3" data-id="element-222">
                <div className="w-10 h-10 rounded-full bg-green-600 text-white font-bold flex items-center justify-center text-sm" data-id="element-223">
                  {t.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
                </div>
                <div data-id="element-224">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-225">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-226">
                    Studente di Veterinaria — {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}